import {
  Music2,
  Snowflake,
  Disc3,
  Skull,
  Heart,
  Crown,
  Moon,
  Flame,
  Zap,
  Radio,
  Guitar,
  ListMusic,
} from "lucide-react";

export const STREAMS = {
  music: {
    name: "All Music",
    description: "Every album, every track",
    color: "#ff2d55",
    genre: "Various",
    icon: Music2,
    artwork: "/albums/music.jpg",
    fallbackImage: "/swansong.city.jpg",
    hasTrackList: true,
  },
  christmas: {
    name: "it's my CHRISTMAS not yours!",
    description: "False Messiah",
    color: "#30d158",
    genre: "Holiday",
    icon: Snowflake,
    artwork: "/albums/christmas.jpg",
    fallbackImage: "/swansong.city.jpg",
    hasTrackList: true,
  },
  dance: {
    name: "Dance Puppets! Harder!",
    description: "Champers Mantard",
    color: "#ff9500",
    genre: "Cult",
    icon: Disc3,
    artwork: "/albums/dance.jpg",
    fallbackImage: "/swansong.city.jpg",
    hasTrackList: true,
  },
  "dirty-scummy-evil": {
    name: "Dirty Scummy Evil",
    description: "Champers Mantard",
    color: "#bf5af2",
    genre: "Cult",
    icon: Skull,
    artwork: "/albums/dirty-scummy-evil.jpg",
    fallbackImage: "/swansong.city.jpg",
    hasTrackList: true,
  },
  "therapists-sister": {
    name: "Therapists Sister",
    description: "Feral & Malign",
    color: "#ff375f",
    genre: "Cult",
    icon: Heart,
    artwork: "/albums/therapists-sister.jpg",
    fallbackImage: "/swansong.city.jpg",
    hasTrackList: true,
  },
  "jommy-family": {
    name: "The Jommy Family EP",
    description: "Jommy's Gaslighting Network",
    color: "#ffcc00",
    genre: "Cult",
    icon: Crown,
    artwork: "/albums/jommy-family.jpg",
    fallbackImage: "/swansong.city.jpg",
    hasTrackList: true,
  },
  lacriminosa: {
    name: "Lacriminosa",
    description: "P₊R.I.D.E / Knuckles",
    color: "#64d2ff",
    genre: "Cult",
    icon: Moon,
    artwork: "/albums/lacriminosa.jpg",
    fallbackImage: "/swansong.city.jpg",
    hasTrackList: true,
  },
  "champers-mantard": {
    name: "Champers Mantard",
    description: "Compilation",
    color: "#ff3b30",
    genre: "Cult",
    icon: Flame,
    artwork: "/albums/champers-mantard.jpg",
    fallbackImage: "/swansong.city.jpg",
    hasTrackList: true,
  },
  "spineless-trump": {
    name: "Smell the Truth™ / These go to Eleven",
    description: "Spineless Trump",
    color: "#ff453a",
    genre: "Cult",
    icon: Zap,
    artwork: "/albums/spineless-trump.jpg",
    fallbackImage: "/swansong.city.jpg",
    hasTrackList: true,
  },
  "the-worst": {
    name: "The Worst Of Us",
    description: "Champers Grifter",
    color: "#5e5ce6",
    genre: "Cult",
    icon: Radio,
    artwork: "/albums/the-worst.jpg",
    fallbackImage: "/swansong.city.jpg",
    hasTrackList: true,
  },
  unplugged: {
    name: "The Worst Of Us - Unplugged",
    description: "False Messiah",
    color: "#ac8e68",
    genre: "Acoustic",
    icon: Guitar,
    artwork: "/albums/unplugged.jpg",
    fallbackImage: "/swansong.city.jpg",
    hasTrackList: true,
  },
  jukebox: {
    name: "Jukebox",
    description: "Request your favorite tracks!",
    color: "#00d4aa",
    genre: "Requests",
    icon: ListMusic,
    artwork: "/albums/jukebox.jpg",
    fallbackImage: "/albums/jukebox.jpg",
    hasTrackList: true,
    isJukebox: true,
  },
} as const;

export type StreamId = keyof typeof STREAMS;

export const FOLDER_TO_STREAM: Record<string, string> = {
  "its-my-christmas-not-yours-album": "christmas",
  "dance-puppets-harder": "dance",
  "dirty-scummy-evil": "dirty-scummy-evil",
  "feral-and-malign": "therapists-sister",
  "the-jommy-family": "jommy-family",
  "knuckles": "lacriminosa",
  "pride": "lacriminosa",
  "these-go-to-eleven": "spineless-trump",
  "the-worst-of-us": "the-worst",
  "the-worst-of-us-unplugged": "unplugged",
};

// Audio latency compensation (seconds) - set to 0 for immediate display
export const NOWPLAYING_DELAY_SECONDS = 0;
